// extracted by mini-css-extract-plugin
export var notificationHost = "_c5-0";